import React from 'react';
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { customColors } from '../../../styles';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
        ...shorthands.overflow('hidden'),
    },
    banner: {
        display: 'flex',
        flexShrink: 0,
        minWidth: 0,
    },
    header: {
        alignItems: 'center',
        backgroundColor: customColors.darkNavy,
        color: tokens.colorNeutralForegroundOnBrand,
        display: 'flex',
        '& h1': {
            paddingLeft: tokens.spacingHorizontalXL,
            display: 'flex',
        },
        height: '48px',
        justifyContent: 'space-between',
        flexShrink: 0,
    },
    body: {
        display: 'flex',
        flex: 1,
        minHeight: 0,
        minWidth: 0,
    },
    sidebar: {
        flexShrink: 0,
        backgroundColor: tokens.colorSubtleBackground, // Use Fluent token for consistency
        ...shorthands.overflow('auto'),
        '@media (max-width: 1000px)': {
            minWidth: '64px',
            width: '64px',
            maxWidth: '64px',
            flexBasis: '64px',
        },
        overflow: 'none',
    },
    mainContent: {
        display: 'flex',
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        ...shorthands.overflow('hidden'),
    },
});

interface ChatLayoutProps {
    bannerContent?: React.ReactNode;
    headerContent?: React.ReactNode;
    sidebarContent: React.ReactNode;
    mainContent: React.ReactNode;
    sidebarWidth?: string;
}

export const ChatLayout: React.FC<ChatLayoutProps> = ({
    bannerContent,
    headerContent,
    sidebarContent,
    mainContent,
    sidebarWidth = '300px',
}) => {
    const classes = useStyles();
    const expandedSidebarStyle: React.CSSProperties = {
        width: sidebarWidth,
        minWidth: sidebarWidth,
        maxWidth: sidebarWidth,
        flexBasis: sidebarWidth,
    };

    return (
        <div className={classes.container}>
            {bannerContent ? <div className={classes.banner}>{bannerContent}</div> : null}
            <div className={classes.header}>{headerContent}</div>
            <div className={classes.body}>
                <div className={classes.sidebar} style={expandedSidebarStyle}>
                    {sidebarContent}
                </div>
                <div className={classes.mainContent}>{mainContent}</div>
            </div>
        </div>
    );
};

export default ChatLayout;
